/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel, nganesan
 * CaseCard component
 * - lists attributes items, allows to drag on plot
 */

import React from 'react';

import Raphael from 'raphael';
import Draggable from './draggable/Draggable.jsx';
import AttrA11yListDropDown from './AttrA11yListDropDown.jsx';
import ToolTip from './common/ToolTip';
import PlainButton from './common/PlainButton';
import Mathjax from './common/Mathjax';
import { requireJrMode } from '../utils/Util.js';

// import AttrListDropDown from './AttrListDropDown.jsx';
// AttrListDropDown not in use
// import {Dyn, DragDropManager} from '../lib/dynDataSet/dynMiscellany';


class AttributeListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.dragInProgress = false;

        // Initial state
        this.state = {
            searchedAttribs: props.attribs,
            showAttribSearch: false,
            numberOfCases: 0,
        };
        this.searchIconRef = React.createRef();
    }

    // To avoid repeated focusing of element which is passed through this.props.eleToFocus
    ignoreFocusing = false

    static getDerivedStateFromProps = (prop, state) => {
        var attribs = prop.attribs;

        if(state.query) {
            attribs = attribs.filter(function(item){
              return item.name.toLowerCase().search(
                state.query.toLowerCase()) !== -1;
            });
        }

        return {
            searchedAttribs: attribs,
            numberOfCases: prop.Dyn.dataSet? prop.Dyn.dataSet.getNumCasesPreFilter(): 0
        };
    }

    selectAttribute = (attr) => {
        // var attributeData = {
        //     id: attr.id,
        //     name: attr.columnName,
        //     object: "cards"
        // };
        // // Call the method to notify others that attribute is selected.
        // mediator.publish( "records:attributeNameSelected", attributeData );

        // Check if event is generated from the first column, don't trigger the selected
        // attribute
        if(this.props.onAttributeNameSelected) {
            this.props.onAttributeNameSelected(attr);
        }
    }

    // Call Add Attribute method if userside validation is done through callback (onAddAttrClick)
    validateAddAttribute = (e) => {
        if(e) {
            e.stopPropagation();
        }
        if(this.props.onAddAttrClick) {
            this.props.onAddAttrClick(
                // Call back function, it can be called from onAddAttrClick definition
                () => {
                this.props.addOrEditAttribute();
                }
            );
        }
    }

    setAttributeColor = (attr) => {
        // Get color gradient and return HTML string '<div..><svg...>...</svg></div>'
        // #1749 - we now pass orientation parameters to makeGradientHTML instead of using css to rotate the SVG afterwards.
        let Dyn = this.props.Dyn,bounds = new Dyn.mathUtil.Rect( 10, 5, 20, 34 ); // fixed color key size
        return Dyn.colorUtil.makeGradientHTML( bounds, attr, false /* vertical */,  true /* pre-filter */ );
    }

    handleKeyDown = (event, attr) => {
        if (event.key === 'Enter') {
            this.selectAttribute(attr);
        }
    };

    handleDragStart = (e, obj, attr) => {
        let Dyn = this.props.Dyn;
        let DragDropManager = Dyn.DragDropManager;
        // To disable cursor change in safari on dragging
        // e.preventDefault();
        // create draggable div
        let eleParent = this.refs["attr_" + attr.id];
        eleParent.classList.toggle("tde-dragging");

        let ele = this.refs['attr_' + attr.id].getElementsByTagName('div')[0].cloneNode(true);
        ele.className = "tde-attribute-grabbing";
        ele.style.left = ( obj.x + 10 )+ 'px';
        ele.style.top = ( obj.y + 10) + 'px';
        // + this.refs.caseDiv.scrollTop
        ele.style.display = 'none';
        // this.refs.caseDiv.appendChild(ele);
        this.props.draggingElementParent.appendChild(ele);
        this.draggingElement = ele;
        /**
        * Get hold of the element which is being dragged
        * TODO: call the set method of DragDrop manager,
        * which can publish the message to plots to
        * highlight the axis
        */
        var draggData = JSON.stringify({
            "value": attr.id,
            "type": 'columnName' //this.getAttribute("attr-type")
        });

        DragDropManager.setDraggedValue( draggData );
    }

    handleDrag = ( e, obj ) => {
        let Dyn = this.props.Dyn;
        let DragDropManager = Dyn.DragDropManager;

        var isFirstTime = ! this.dragInProgress;
        DragDropManager.dragInProgress( e, obj, isFirstTime );
        if ( this.dragInProgress === false ){
            this.dragInProgress = true;
        }
        // Reposition the draggable div
        this.draggingElement.style.left = ( obj.x + 10 ) + 'px';
        this.draggingElement.style.top = ( obj.y + 10 ) + 'px';
        //(obj.y) - this.refs.caseDiv.scrollTop
        this.draggingElement.style.display = 'block';

        // based on matches, set the style for the drop area
        // var matches = DragDropManager.draggedMatchesTarget();

        /**
        * Eliminate the animation on revert for matches.
        * We have to set the revert duration here instead of "stop"
        * in order to have the change take effect.
        */
        // TODO: Need to check the purpose of following line
        // $(e.target).draggable( "option","revertDuration",( matches ) ? 0 : 200 );
    }

    handleDragEnd = (e, obj, attr) => {
        let Dyn = this.props.Dyn;
        let DragDropManager = Dyn.DragDropManager;
        // Remove the draggable element and set the dragInProgress to false
        this.dragInProgress = false;
        // this.refs.caseDiv.removeChild(this.draggingElement);
        this.props.draggingElementParent.removeChild(this.draggingElement);

        let eleParent = this.refs["attr_" + attr.id];
        eleParent.classList.toggle("tde-dragging");

        // Handle the end state. Disable correct drops
        // then reset the standard cursor..

        /**
        * once the drag is end, remove the highlight
        * publish the message to end the highlight
        * Dropped on a non-matching target.
        */
        var clientX = obj.x,
            clientY = obj.y;
        setTimeout(()=>{
            DragDropManager.dragEnd(e, { x: clientX, y: clientY });
        }, 100);

        // TODO: Need to check the purpose of the following lines
        // if ( !DragDropManager.draggedMatchesTarget() ) return;
        // $( e.target ).draggable( "disable" );
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        if(Dyn.dataSet) {
            return Dyn.loc( str );
        } else {
            return str;
        }
    }

    gotoRecord = (direction, e) => {
        e.stopPropagation();
        var index = this.props.recordIndex;
        switch(direction) {
            case 'next':
                if(this.state.numberOfCases-1 > index) {
                    index++;
                }
            break;
            case 'prev':
                if(index > 0) {
                    index--;
                }
            break;
        }
        if(this.props.onAttributeCasesSelected) {
            this.props.onAttributeCasesSelected([index]);
        }
    }

    getDatasetSummary = () => {
        let Dyn = this.props.Dyn;
        return Dyn.dataSet? Dyn.dataSet.getDatasetSummary(): '';
    }

    filterAttribs = (val) => {
        // var attribs = this.props.attribs;
        // if(val) {
        //     attribs = attribs.filter(function(item){
        //       return item.name.toLowerCase().search(
        //         val.toLowerCase()) !== -1;
        //     });
        // }
        this.setState({query: val});
    }

    searchAttribs = (event) => {
        if(this.searchInputTimeout) {
            clearTimeout(this.searchInputTimeout);
        }
        let val = event.target.value;
        this.searchInputTimeout = setTimeout(() => {
            this.filterAttribs(val);
        }, 150);
    }

    toggleSearchInput = () => {
        // To toggle attribute search input
        var showAttribSearch = !this.state.showAttribSearch;
        this.setState({showAttribSearch: showAttribSearch});
        if(!showAttribSearch) {
            this.filterAttribs();
        }
    }

    handleInputKeyDownEvent = (e) => {
        // Hide search input field when hit esc
        if(e.keyCode == 27) {
            this.toggleSearchInput();
            e.preventDefault();
            this.searchIconRef.current.focus();
        }
    }

    updateAttributeDisplay = (e) => {
        let Dyn = this.props.Dyn;
        const viewOnly = this.props.Dyn.preferences.isViewOnly();
        if(viewOnly) {
            return;
        }
        if (this.props.Dyn.preferences.isDisplayAttributeSettingOn() && Dyn.dataSet && !requireJrMode(this.props.mode)){
            var isAnyAttributeHidden = Dyn.dataSet.isAnyAttributeHidden();
            let props = {};
            if(!this.ignoreFocusing && this.props.eleToFocus && this.props.eleToFocus === "ATTR_DIS") {
                this.ignoreFocusing = true;
                // To auto focus
                props = {
                    ref: (ele) => {ele && ele.focus()}
                }
            }
            return <div className={'tde-attribute-actions tde-text-left tde-attributes-td' + (isAnyAttributeHidden===true? ' tde-cell-active':'')}>
                <ToolTip tip={this.getLoc('Attribute Display Settings')} Dyn={this.props.Dyn}>
                    <PlainButton {...props} onClick={this.props.displaySettingAttribute} key="case-display" aria-label={this.getLoc('Attribute Display Settings')}>
                        <i className="tde-i tde-i-eye tde-font-weight-regular tde-primary-text-color"></i>
                    </PlainButton>
                </ToolTip>
            </div>
        } else {
            return <div className="tde-attributes-td tde-attribute-actions"></div>
        }
    }

    allowCustomAttribute = (e) => {
        let Dyn = this.props.Dyn;
        const viewOnly = this.props.Dyn.preferences.isViewOnly();
        // Show Add New Attribute option when viewOnly is false
        // && !['jr', 'elem'].includes(this.props.mode)
        if ( Dyn.dataSet && this.props.Dyn.preferences.isCustomAttributeOn() && !viewOnly){
            let props = {};
            if(!this.ignoreFocusing && this.props.eleToFocus && this.props.eleToFocus === "ATTR_NEW") {
                this.ignoreFocusing = true;
                // To auto focus
                props = {
                    ref: (ele) => {ele && ele.focus()}
                }
            }
            return <PlainButton {...props} key="case-add"
                        className="tde-attributes-row tde-add-attr-btn tde-font-weight-medium tde-s1 tde-btn-full-width tde-p-2 tde-text-center tde-divider-top"
                        aria-label={this.getLoc('Add Attribute')} style={{display: 'block', height: '38px'}}
                        onClick={this.validateAddAttribute}>
                        <i className="tde-i tde-i-add"></i>{" "}{this.getLoc('Add Attribute')}
                    </PlainButton>
        }
        /*
        else {
            return <td key="case-add" className="tde-attribute-actions"></td>
        }
        */
    }

    // To populate html for a single attribute row
    getAttribRow = (attr) => {
        const _requireJrMode = requireJrMode(this.state.mode);
        let showAttributeContextMenu = this.props.Dyn.preferences.isAttributeContextMenu();
        const viewOnly = this.props.Dyn.preferences.isViewOnly();
        let additionalEditEleProps = {};
        if(!this.ignoreFocusing && this.props.eleToFocus && this.props.eleToFocus === "ATTR_ID:" + attr.id) {
            this.ignoreFocusing = true;
            // To auto focus
            additionalEditEleProps = {
                ref: (ele) => {ele && ele.focus()}
            }
        }
        var attrCell;
        if(viewOnly) {
            attrCell = <div className={"tde-attributes-td tde-attribute-name tde-view-only tde-text-left tde-s1 tde-font-weight-regular tde-pl-2 tde-pr-1 tde-cell" + ((this.props.onPlotAttribIds.indexOf(attr.id)>=0)?' tde-active':'')}
                    ref={"attr_" + attr.id}>
                        <ToolTip tip={attr.longName} Dyn={this.props.Dyn} dir="r">
                            <div><Mathjax value={attr.name} /></div>
                        </ToolTip>
                    </div>
        } else {
            attrCell = <Draggable
                    key={attr.id}
                    onStart={(e, obj) => {
                        this.handleDragStart(e, obj, attr);
                    }}
                    onDrag={this.handleDrag}
                    onStop={(e, obj) => {
                        this.handleDragEnd(e, obj, attr);
                    }}
                >
                    <div className={"tde-attributes-td tde-attribute-name tde-cursor-grab tde-text-left tde-s1 tde-font-weight-regular tde-pl-2 tde-pr-1 tde-cell" + ((this.props.onPlotAttribIds.indexOf(attr.id)>=0)?' tde-active':'') + (_requireJrMode ? ' tde-divider-right2' :'')}
                    onKeyDown={(event) => this.handleKeyDown(event, attr)}
                    onClick={this.selectAttribute.bind(this, attr)}
                    role="button"
                    aria-labelledby={"label_" + attr.id}
                    aria-pressed={(this.props.onPlotAttribIds.indexOf(attr.id)>=0)}
                    draggable="false" ref={"attr_" + attr.id}>
                        <ToolTip tip={attr.longName} Dyn={this.props.Dyn} dir="r">
                            <div id={"label_" + attr.id}><Mathjax value={attr.name} /></div>
                        </ToolTip>
                    </div>
                </Draggable>
        }
        let colorRectStyle = {};
        if(viewOnly) {
            colorRectStyle = {
                overflow: 'hidden',
                marginRight: 8,
                cursor: 'default'
            }
        }
        return <div key={attr.id} className={ "tde-attributes-row tde-divider-bottom3 draggable-element " + (this.props.onPlotAttribIds.indexOf(attr.id)>=0?'tde-onaxis':'') + (this.props.selectedAttribID===attr.id?' tde-active':'')}>
                {attrCell}
                <div className="tde-attributes-td tde-attribute-value tde-text-left tde-s1 tde-font-weight-regular tde-pl-2 tde-pr-1"  draggable="false">
                    <ToolTip tip={attr.rawAttr.caseValueToString(this.props.recordIndex)} Dyn={this.props.Dyn} dir="r">
                        <div>{attr.rawAttr.caseValueToString(this.props.recordIndex)}</div>
                    </ToolTip>
                </div>

                <div className={"tde-attributes-td tde-attribute-color "} // + (attr.rawAttr.stats.isNumeric() == true ? 'tde-rotate--90' : '')}
                    style={colorRectStyle}
                    dangerouslySetInnerHTML={{
                        __html: this.setAttributeColor(attr.rawAttr)
                    }}
                    onClick={ !viewOnly ? this.selectAttribute.bind(this, attr) : undefined }
                    draggable="false" >
                </div>

                {!viewOnly && showAttributeContextMenu && <AttrA11yListDropDown {...this.props} attr={attr} getLoc={this.getLoc}></AttrA11yListDropDown>}

                {!viewOnly && !showAttributeContextMenu && <div className={
                    "tde-attributes-td tde-attribute-actions tde-text-left" +
                    (this.props.filteredAttribIds.indexOf(attr.id) >= 0
                        ? " tde-cell-active"
                        : "")
                    }
                    draggable="false">
                    <PlainButton
                        {...additionalEditEleProps}
                        onClick={e => {
                            e.stopPropagation();
                            this.props.addOrEditAttribute(attr)
                        }}
                        aria-label={this.props.Dyn.loc('Edit {{attributename}} Attribute', {"attributename": attr.name})}
                    >
                        <i className="tde-i tde-i-pencil"></i>
                    </PlainButton>
                </div>}
        </div>
    }

    render = () => {
        const _requireJrMode = requireJrMode(this.props.mode);
        var datasetSummary = this.getDatasetSummary();
        const viewOnly = this.props.Dyn.preferences.isViewOnly();
        return (
            <div className="tde-fill" style={this.props.style}>
                {this.props.showHeader === true &&
                    <div className="tde-case-card-header tde-sliding-panel-header tde-divider-bottom2">
                        <div className="tde-text-left tde-d-flex tde-flex-items-center">
                            <span
                                className="tde-title tde-h6 tde-font-weight-bold tde-ml-2 tde-card-title-text-color"
                                role="heading"
                                aria-level="1">
                                    {this.getLoc("CASE CARD")}
                            </span>
                            <div>
                                <PlainButton
                                    className={"tde-ml-2"+(_requireJrMode ? ' tde-border ': '')}
                                    aria-label={this.getLoc('Move Up One Case')}
                                    onClick={this.gotoRecord.bind(this, "prev")}
                                    aria-disabled={this.props.recordIndex === 0}
                                >
                                    <i
                                        className="tde-navigation-button tde-i tde-i-previous tde-primary-text-color"
                                        style={{ lineHeight: 1 }}
                                    ></i>
                                </PlainButton>
                                <span className="tde-ml-2 tde-s1 tde-no-wrap">
                                    {Math.min(this.props.recordIndex + 1, this.state.numberOfCases)} of{" "}
                                    {this.state.numberOfCases}
                                </span>
                                <PlainButton
                                    className={"tde-ml-2"+(_requireJrMode ? ' tde-border ': '')}
                                    aria-label={this.getLoc('Move Down One Case')}
                                    onClick={this.gotoRecord.bind(this, "next")}
                                    aria-disabled={this.props.recordIndex === this.state.numberOfCases - 1}
                                >
                                    <i
                                        className="tde-i tde-i-next tde-primary-text-color"
                                        style={{ lineHeight: 1 }}
                                    ></i>
                                </PlainButton>
                            </div>
                            <div id="plotDescription" style={{ display: 'none' }}>{datasetSummary}</div>
                            <div className='tde-ml-auto'>
                                <ToolTip tip={datasetSummary} Dyn={this.props.Dyn}>
                                    <PlainButton
                                        ref="datasetSummary"
                                        aria-label={this.getLoc('Dataset Details')}
                                        aria-describedby="plotDescription"
                                        className="tde-mr-2 tde-text-right tde-flex-1 tde-primary-text-color"
                                    >
                                        <i
                                            className="tde-i tde-i-exclamation"
                                            style={{ lineHeight: 1 }}
                                        ></i>
                                    </PlainButton>
                                </ToolTip>
                            </div>
                        </div>
                    </div>
                }
                <div className="tde-case-card-body tde-sliding-panel-body tde-bg2-color">
                    <div className="tde-attributes-wrapper">
                        <div className="tde-attributes-row tde-onaxis tde-divider-bottom2 tde-card-content-bg-color tde-primary-text-color" key="case">
                            <div className={"tde-attributes-td tde-attribute-name tde-text-left tde-s1 tde-pl-2 tde-pr-1" + (_requireJrMode ? ' tde-divider-right2' : '')}>
                                {this.getLoc("Attribute")}
                                { !viewOnly &&
                                <ToolTip tip={this.getLoc('Search for Attributes')} Dyn={this.props.Dyn}>
                                    <PlainButton
                                        ref={this.searchIconRef}
                                        onClick={this.toggleSearchInput}
                                        aria-label={this.getLoc('Search for Attributes')}
                                        aria-expanded={this.state.showAttribSearch}
                                    >
                                        <i
                                            className="tde-i tde-i-search tde-primary-text-color tde-ml-1"
                                            style={{
                                                marginRight: "5px",
                                                paddingRight: "5px",
                                                // borderRight: "1px solid #f5f5f5"
                                            }}
                                        ></i>
                                    </PlainButton>
                                </ToolTip>
                                }
                            </div>
                            <div className="tde-attributes-td tde-attribute-value tde-s1 tde-text-left tde-pl-2">
                                {this.getLoc("Value")}
                            </div>
                            {this.updateAttributeDisplay()}
                        </div>

                        {this.state.showAttribSearch && (
                            <div className="tde-attributes-row -bottom tde-card-content-bg-color tde-primary-text-color">
                                <div className="tde-attributes-td tde-search-attribute">
                                    <i className="tde-i tde-i-search tde-primary-text-color" aria-hidden="true"></i>
                                    <input
                                        type="text"
                                        className="tde-input-text"
                                        placeholder={this.getLoc("Search")}
                                        aria-label={this.getLoc('Search for Attributes')}
                                        ref={input => {
                                            input && input.focus();
                                        }}
                                        onChange={this.searchAttribs}
                                        onKeyDown={
                                            this.handleInputKeyDownEvent
                                        }
                                    />
                                </div>
                            </div>
                        )}

                        { this.state.searchedAttribs.map((attr, i) => {
                                if ( attr.isVisible ) {
                                    if(this.props.dataType) {
                                        return this.getAttribRow(attr, true)
                                    } else {
                                        return this.getAttribRow(attr, false);
                                    }
                                }
                            }) }
                        { this.allowCustomAttribute() }
                    </div>
                </div>
            </div>
        );
    }
}

export default AttributeListComponent;
